<template>
  <div
    class="clariant-map-container"
    id="locations-map-container"
    :data-theme="config.mapTheme"
  >
    <datalist>
      <option
        v-for="p in pinsWithCoordinates"
        :key="p.id"
        :data-id="p.id"
        :value="getInfoboxContent(p)"
        :data-title="p.name"
        :data-latitude="p.latitude"
        :data-longitude="p.longitude"
      />
    </datalist>
    <div class="map-wrapper">
      <div id="map-locations" class="clariant-map"></div>
      <div class="map-search-container nevazut">
        <input
          type="search"
          class="map-search "
          :placeholder="labels.mapSearchPlaceholder"
          data-addressonly="false"
          data-matchingonly="false"
        />
        <a href="#" class="map-search-icon-link icon-link-clear"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { Labels, Config, Utils } from "../services.js";

export default {
  name: "Map",
  props: ["pins"],
  components: {},
  data() {
    return {
      labels: Labels,
      config: Config,
      pinsWithCoordinates: [],
    };
  },
  mounted() {
    if (this.pins && this.pins.length > 0) {
      this.pinsWithCoordinates = this.pins.filter(
        (x) => x.coordinatesAvailable
      );
      if (this.pinsWithCoordinates.length > 0) {
        this.initMap();
      }
    }
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    pins(val) {
      this.pinsWithCoordinates = val.filter((x) => x.coordinatesAvailable);
      if (this.pinsWithCoordinates.length > 0) {
        this.initMap();
      }
    },
  },
  methods: {
    initMap() {
      const self = this;
      if (!window.cla.assetManager) {
        console.error("Asset manager not initialized!");
        return;
      }
      window.cla.assetManager.loadStylesheet("/styles/components/maps.css");
      window.cla.assetManager.loadScript(
        "/scripts/components/maps.js",
        function() {
          if (!window.cla.mapsManager) {
            console.error("Maps manager not initialized!");
            return;
          }
          if (window.cla.mapsManager.initialized) {
            google.charts.setOnLoadCallback(window.cla.mapsManager.drawMaps);
          } else {
          window.cla.mapsManager.init(Config.mapApiKey);
          }
          window.cla.mapsManager.initMap("#locations-map-container", function(
            map
          ) {
            self.onResize();
          });
        }
      );
    },
    getInfoboxContent(pin) {
      if (!pin) return "";
      return `<div><strong>${pin.name}</strong></div>
        <div class="company-name">${pin.companyName}</div>
        <div class="address">${pin.address1}</div>
        <div class="address"${pin.address2}</div>
        <div class="address"><span>${pin.postalCode}&nbsp;</span><span>${pin.postalLocation || pin.city}</span>&nbsp;<span>${pin.state}</span>&nbsp;</div>
        <div class="address">${pin.country}</div>
        ${pin.phone ? '<div class="phone">' + pin.phone + '</div>' : ''}`;
    },
    onResize() {
      /*Utils.debounce(
        "mapResize",
        () => {
          if (window.cla.mapsManager) {
            window.cla.mapsManager.drawMaps();
          }
        },
        200
      );*/
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clariant-map-container {
  width: 70vw;
}
.clariant-map {
  height: 60vh;
}

@media all and (max-width: 780px) {
 .clariant-map-container {
    width: 100vw;
  }
  .clariant-map {
    height: 80vh;
  } 
}
</style>
